import React from 'react';
import { store } from '../../store'
import TilbodNavigation from '../tilbod-navigation'
import Quote from '../quote'
import Modal from 'react-modal';
import { SigningModal } from '../modals'
import { createContract, checkContractStatus } from '../../api/offers/actions'
import { SvgCheckIcon, SvgArrowIcon } from '../svg';

import { nextStep, prevStep, setStep, openModal, closeModal, setActiveCustomerId, setActiveContractType } from '../../api/gui/actions'
import connectWithStore from '../../utils/store'


import { customerNameById, formatKennitala, formatKennitalaAsDate, Spinner } from '../../utils'

import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import { STEP_FINAL } from '../../constants';


var timers = {}


class TilbodStepSignature extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showSigning: false
        }
    }

    componentWillUpdate() {
        if (this.props.gui.currentStep === 4) {


            var oneContractStillOpen = true
            if (Object.keys(timers).length > 0) {
                var oneContractStillOpen = false
                for (var t in timers) {
                    if (this.props.offers.contractSigningStatus[t] === "signing_completed") {
                        clearInterval(timers[t])
                    } else {
                        oneContractStillOpen = true
                    }
                }
            }
            var shouldCloseModal = !oneContractStillOpen
            if (shouldCloseModal) {
                this.props.dispatch(setStep(STEP_FINAL))
            }
        }
    }

    componentDidMount() {
        let data = Object.assign({}, this.props.offers)
        data = Object.assign(data, this.props.customers)
        data.infoCollection = this.props.infoCollection
        data.healthQuestions = this.props.healthQuestions
        data.physical_signing = true
        data.euro_value = this.props.gui.currency

        Promise.resolve(this.props.dispatch(createContract(JSON.stringify(data))))
            .then((receivedData) => {
                this.setState({ showSigning: true })

                for (var id of this.props.offers.contractSigning.contract_ids) {
                    timers[id] = setInterval(() => this.props.dispatch(checkContractStatus(id)), 15000)
                }

            })
    }

    onNavLinkClick(e) {
        var tab = $(e.target).parents('.nav-item').prev('.nav-item');

        $('.tabs .nav-item').removeClass('no-border');
        tab.addClass('no-border');
    }

    render() {
        let customers = this.props.customers;
        const { contractSigning, isFetching } = this.props.offers
        return (
            <>
                <div className="row justify-content-center xs-pt-10 signature">
                    <div className="col-12 col-sm-10 col-md-8">
                        <div className="row justify-content-center xs-pt-10">
                            <Tab.Container id="base-info-collection-tabs" defaultActiveKey={Object.keys(this.props.offers.offerQueryParameters)[0]} >
                                <div className="tabs-container">
                                    <Nav variant="tabs" className="tabs">
                                        {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                            <Nav.Item className="check">
                                                <Nav.Link eventKey={customerId} onClick={this.onNavLinkClick.bind(this)}>
                                                    {/* <Nav.Link eventKey={customerId}> */}
                                                    {customerNameById(customerId, this.props.customers)}<span>({formatKennitala(customerId)})</span>
                                                </Nav.Link>
                                                <span className="check-icon small blue">
                                                    <SvgCheckIcon />
                                                </span>
                                            </Nav.Item>
                                        )}
                                    </Nav>
                                </div>

                                <Tab.Content className="w-100">
                                    {isFetching && <Spinner />}
                                    {this.state.showSigning && contractSigning.signing_urls !== undefined &&
                                        <>
                                            {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>

                                                <Tab.Pane className="h-100" eventKey={customerId}>

                                                    <Tab.Container id="contract-signing-tabs" defaultActiveKey={`${customerId}-${Object.keys(contractSigning.signing_urls[customerId])[0]}`} >
                                                        <Nav variant="tabs" className="mb-3 w-100" activeKey={this.props.gui.signing.activeContractType}>
                                                            {Object.keys(contractSigning.signing_urls[customerId]).map((productCode, idx) =>
                                                                <Nav.Item>
                                                                    <Nav.Link eventKey={`${customerId}-${productCode}`} onSelect={selectedKey => this.props.dispatch(setActiveContractType(productCode))}>
                                                                        {productCode}
                                                                    </Nav.Link>
                                                                </Nav.Item>
                                                            )}
                                                        </Nav>

                                                        <Tab.Content className="w-100 h-100">
                                                            {Object.keys(contractSigning.signing_urls[customerId]).map((productCode, idx) =>
                                                                <Tab.Pane className="h-100" eventKey={`${customerId}-${productCode}`}>
                                                                    <iframe className="w-100" src={contractSigning.signing_urls[customerId][productCode]} />
                                                                </Tab.Pane>
                                                            )}
                                                        </Tab.Content>
                                                    </Tab.Container>

                                                </Tab.Pane>
                                            )}
                                        </>
                                    }

                                </Tab.Content>
                            </Tab.Container>
                        </div>
                        {/* <div className="row steps-container">
                                <div className="steps">
                                    <div className="step complete">
                                        <span className="arrow-container">
                                            <SvgArrowIcon/>
                                        </span>
                                        Leben
                                        <span className="check-container">
                                            <SvgCheckIcon/>
                                        </span>
                                    </div>
                                    <div className="step active">
                                        <span className="arrow-container">
                                            <SvgArrowIcon/>
                                        </span>
                                        Renten
                                        <span className="check-container">
                                            <SvgCheckIcon/>
                                        </span>
                                    </div>
                                    <div className="step">
                                        <span className="arrow-container">
                                            <SvgArrowIcon/>
                                        </span>
                                        Fenten
                                        <span className="check-container">
                                            <SvgCheckIcon/>
                                        </span>
                                    </div>
                                    <div className="step">
                                        <span className="arrow-container">
                                            <SvgArrowIcon/>
                                        </span>
                                        Centen
                                        <span className="check-container">
                                            <SvgCheckIcon/>
                                        </span>
                                    </div>
                                    <div className="step">
                                        <span className="arrow-container">
                                            <SvgArrowIcon/>
                                        </span>
                                        Genten
                                        <span className="check-container">
                                            <SvgCheckIcon/>
                                        </span>
                                    </div>
                                </div>
                            </div> */}
                    </div>
                </div>

            </>
        )
    }
}

TilbodStepSignature.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        nationalRegistry: {},
        infoCollection: {},
        healthQuestions: {}
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
    f.healthQuestions = (state.healthQuestions === undefined) ? {} : state.healthQuestions
    return f;
}

export default connectWithStore(store, TilbodStepSignature, mapStateToProps);
